<template>
  <div>
    <Head :title="__('Users')" />
      <div class="mb-6 flex flex-col md:flex-row gap-3 justify-between items-center ticket-filters">
          <search-filter v-model="form.search" class="mr-4 w-full max-w-md" @reset="reset">
              <label class="block text-gray-700">Trashed:</label>
              <select v-model="form.trashed" class="mt-1 w-full form-select">
                  <option :value="null" />
                  <option value="with">With Trashed</option>
                  <option value="only">Only Trashed</option>
              </select>
          </search-filter>
          <div class="filter-add-new flex flex-col gap-3 md:flex-row w-full items-center max-w-md">
              <select-input v-model="form.role_id" class=" mr-2 w-full">
                  <option :value="null">{{ __('Filter by role') }}</option>
                  <option v-for="(r, ri) in roles" :key="ri" :value="r.id">{{ r.name }}</option>
              </select-input>
              <Link class="btn-indigo" :href="route('users.create')">
                  <span>{{ __('Create New') }}</span>
              </Link>
          </div>
      </div>
    <div class="bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <tr class="text-left font-bold">
          <th class="pb-4 pt-6 px-6">{{ __('Name') }}</th>
          <th class="pb-4 pt-6 px-6">{{ __('Email') }}</th>
          <th class="pb-4 pt-6 px-6">{{ __('Phone') }}</th>
            <th class="pb-4 pt-6 px-6">{{ __('Country') }}</th>
            <th class="pb-4 pt-6 px-6">{{ __('City') }}</th>
            <th class="pb-4 pt-6 px-6" colspan="2">{{ __('Role') }}</th>
        </tr>
        <tr v-for="user in users.data" :key="user.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
          <td class="border-t">
            <Link class="flex items-center px-6 py-4 focus:text-indigo-500" :href="route('users.edit', user.id)">
              <img v-if="user.photo" class="block -my-2 mr-2 w-5 h-5 rounded-full" :src="user.photo" />
              {{ user.name }}
              <icon v-if="user.deleted_at" name="trash" class="flex-shrink-0 ml-2 w-3 h-3 fill-gray-400" />
            </Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-6 py-4" :href="route('users.edit', user.id)" tabindex="-1">
              {{ user.email }}
            </Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-6 py-4" :href="route('users.edit', user.id)" tabindex="-1">
              {{ user.phone }}
            </Link>
          </td>
            <td class="border-t">
                <Link class="flex items-center px-6 py-4" :href="route('users.edit', user.id)" tabindex="-1">
                    {{ __(user.country) }}
                </Link>
            </td>
            <td class="border-t">
                <Link class="flex items-center px-6 py-4" :href="route('users.edit', user.id)" tabindex="-1">
                    {{ __(user.city) }}
                </Link>
            </td>
          <td class="border-t capitalize">
            <Link class="flex items-center px-6 py-4" :href="route('users.edit', user.id)" tabindex="-1">
              {{ user.role?user.role.name:null }}
            </Link>
          </td>
          <td class="w-px border-t">
            <Link class="flex items-center px-4" :href="route('users.edit', user.id)" tabindex="-1">
              <icon name="cheveron-right" class="block w-6 h-6 fill-gray-400" />
            </Link>
          </td>
        </tr>
        <tr v-if="users.data.length === 0">
          <td class="px-6 py-4 border-t" colspan="6">No users found.</td>
        </tr>
      </table>
    </div>
      <pagination class="mt-6" :links="users.links" />
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Icon from '@/Shared/Icon'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import Pagination from '@/Shared/Pagination'
import SearchFilter from '@/Shared/SearchFilter'
import SelectInput from '@/Shared/SelectInput'

export default {
  components: {
    Head,
    Icon,
    Link,
    SearchFilter,
      SelectInput,
      Pagination,
  },
  layout: Layout,
  props: {
    filters: Object,
    users: Object,
    roles: Array,
  },
  data() {
    return {
      form: {
        search: this.filters.search,
        role_id: this.filters.role_id ?? null,
        trashed: this.filters.trashed,
      },
    }
  },
  watch: {
    form: {
      deep: true,
      handler: throttle(function () {
        this.$inertia.get(this.route('users'), pickBy(this.form), { preserveState: true })
      }, 150),
    },
  },
  methods: {
    reset() {
      this.form = mapValues(this.form, () => null)
    },
  },
}
</script>
